<template>
  <div>
    <div class="top">
      <!-- <header class="menu-bar-top-margin">
        <menu-bar></menu-bar>
      </header> -->
    </div>
    <diV>
      <section>
        <router-view></router-view>
      </section>
    </diV>
    <!-- <div>
      <fixed-footer></fixed-footer>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "landing-page",
  components: {}
};
</script>

<style scoped></style>
